import Alert from '@customink/pigment-react/lib/components/Alert';
import { useEffect } from 'react';

import { CustomerCareLink } from '@/components/CustomerCareLink';
import { spacing8 } from '@/utils/designTokens';
import { pageViewTag } from '@/utils/metrics';

export default function CheckoutError({}) {
  useEffect(() => {
    pageViewTag(`checkout/summary/proceed_error`);
  }, []);

  return (
    <Alert severity="error" sx={{ marginY: spacing8 }}>
      We’ve encountered a error with this order. Please call us at{' '}
      <CustomerCareLink /> for assistance.
    </Alert>
  );
}
